<template>
  <material-card
    :title="
      mode === 'plan'
        ? $t('components.drawer.plan_files')
        : $t('components.employers.employer_details.employers_uploads')
    "
    :color="$vuetify.theme.themes.light.secondary"
    icon="description"
    v-if="selectedPlan !== null && selectedPlan !== undefined"
  >
    <pbas-data-table
      ref="table"
      :exporters="$exporters"
      :dataProvider="provider"
      :selectAll="true"
      :showSelect="true"
      :selectActions="selectActions"
      :rowActions="rowActions"
      :floatActions="floatActions"
      fileNamePrefix="files"
      identifier="planFiles"
      @error="error = $event"
      :canExpand="(item) => item.HasHistory"
      :showExpand="true"
      :generateProviderForExpanded="(item) => generateDependantProvider(item)"
    ></pbas-data-table>
    <error-handler :error="error"></error-handler>
    <v-dialog v-model="dialogs.add" max-width="800" persistent scrollable>
      <material-card
        :title="$t('views.plandownloadcenter.add_file')"
        :color="$vuetify.theme.themes.light.success"
        icon="add"
      >
        <v-card-text>
          <v-form
            style="margin:20px"
            v-if="dialogs.add && file !== null && file !== undefined"
            v-model="valid.add"
          >
            <div class="row">
              <div class="col-12 col-md-6" v-if="mode === 'plan'">
                <pbas-date-picker
                  :label="$t('components.memberview.select_effective_date')"
                  :value="file.EffectiveDate"
                  @update-date="file.EffectiveDate = $event"
                  class="required"
                  :rules="[$rules.required]"
                ></pbas-date-picker>
              </div>
              <div class="col-12 col-md-6">
                <!-- <auto-select
                  :value.sync="file.Identity.FileCategory"
                  :items="options.Enums.PlanFileCategory"
                  :label="$t('globals.category')"
                  :rules="[$rules.required]"
                  class="required"
                  :slots="true"
                  :filter="filterFunc"
                >
                  <template v-slot:selection="data">
                    {{ $t("enums." + data.item) }}
                  </template>
                  <template v-slot:item="data">
                    <v-list-item-content
                      v-text="$t('enums.' + data.item)"
                    ></v-list-item-content>
                  </template>
                </auto-select> -->
                <trans-enum
                  :value.sync="file.Identity.FileCategory"
                  :items="filteredCategories"
                  :label="$t('globals.category')"
                  :rules="[$rules.required]"
                  class="required"
                ></trans-enum>
              </div>
              <template
                v-if="file.Identity.FileCategory === 'RegularRemmitanceUpload'"
              >
                <div class="col-12 col-md-6">
                  <pbas-date-picker
                    :label="$t('headers.member_files.pay_period_start_date')"
                    :value="file.PeriodStartDate"
                    @update-date="file.PeriodStartDate = $event"
                    class="required"
                    :rules="[$rules.required]"
                  ></pbas-date-picker>
                </div>
                <div class="col-12 col-md-6">
                  <pbas-date-picker
                    :label="$t('headers.member_files.pay_period_end_date')"
                    :value="file.PeriodEndDate"
                    @update-date="file.PeriodEndDate = $event"
                    class="required"
                    :rules="[$rules.required]"
                  ></pbas-date-picker>
                </div>
              </template>
              <div class="col-12 col-md-6">
                <trans-select2
                  v-model="file.Identity"
                  propertyName="Employer"
                  transPropertyName="Current"
                  tra
                  :items="employers"
                  :label="$t('headers.members_management.Employer')"
                  field="Name"
                  itemValue="Id"
                  clearable
                  :rules="mode === 'employer' ? [$rules.required] : []"
                  :class="mode === 'employer' ? 'required' : ''"
                ></trans-select2>
              </div>
              <div class="col-12 col-md-6" v-if="stores && stores.length > 0">
                <trans-select2
                  v-model="file.Identity"
                  propertyName="Store"
                  transPropertyName="Current"
                  :items="stores"
                  :label="$t('headers.members_management.Store')"
                  field="Name"
                  itemValue="Id"
                ></trans-select2>
              </div>
            </div>
            <template v-if="file.Identity.FileCategory">
              <div class="row" v-for="(lang, index) of languages" :key="index">
                <span>{{ lang.title }}</span>
                <div class="col-md-12 col-xs-12">
                  <no-autocomplete-textfield
                    @change="bindName($event, lang)"
                    :label="$t('globals.name')"
                    :rules="
                      lang.language === language.language
                        ? [$rules.required]
                        : []
                    "
                    :class="
                      lang.language === language.language ? 'required' : ''
                    "
                  ></no-autocomplete-textfield>
                </div>
                <div class="col-md-12 col-xs-12">
                  <single-file-upload2
                    :id="'addPlanFileId' + index"
                    @emit-upload-start="saving = true"
                    @emit-upload-end="saving = false"
                    :label="$t('views.plandownloadcenter.file')"
                    :tags="[selectedPlan.UniqueIdentifier]"
                    :categories="[file.Identity.FileCategory]"
                    :currentFolder="selectedPlan.Name"
                    :fileUploadUrl="
                      settings.DOCUMENTSERVICEURL + 'api/UploadFiles'
                    "
                    @emit-files="
                      bindFile($event, lang);
                      saving = false;
                    "
                    @emit-upload-error="
                      error = $event;
                      saving = false;
                    "
                    :getFilesUrl="settings.DOCUMENTSERVICEURL + 'api/Files'"
                    :files="files"
                    :rules="
                      lang.language === language.language
                        ? [$rules.required]
                        : []
                    "
                    :class="
                      lang.language === language.language ? 'required' : ''
                    "
                  />
                </div>
              </div>
            </template>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn
            text
            @click="
              dialogs.add = false;
              file = null;
            "
          >
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn
            color="primary"
            :loading="saving"
            @click="tryAddFile"
            :disabled="!valid.add"
          >
            {{ $t("globals.save") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <v-dialog v-model="dialogs.edit" max-width="800" persistent scrollable>
      <material-card
        :title="
          $t('views.plandownloadcenter.edit_file_{0}', [
            translate2(selectedItem.Current, 'Name'),
          ])
        "
        :color="$vuetify.theme.themes.light.primary"
        icon="edit"
        v-if="selectedItem !== null && selectedItem !== undefined"
      >
        <v-card-text>
          <v-form style="margin:20px" v-model="valid.edit">
            <div class="row">
              <div class="col-12 col-md-6">
                <pbas-date-picker
                  :label="$t('components.memberview.select_effective_date')"
                  :value="effectiveDate"
                  @update-date="effectiveDate = $event"
                  class="required"
                  :rules="[$rules.required]"
                ></pbas-date-picker>
              </div>
            </div>
            <template v-if="file !== null && file !== undefined">
              <div class="row" v-for="(lang, index) of languages" :key="index">
                <span>{{ lang.title }}</span>
                <div class="col-md-12 col-xs-12">
                  <no-autocomplete-textfield
                    @change="bindName($event, lang)"
                    :label="$t('globals.name')"
                    :rules="lang.language === 'en' ? [$rules.required] : []"
                    :class="lang.language === 'en' ? required : ''"
                    :value="translate(file, lang, 'Name')"
                  ></no-autocomplete-textfield>
                </div>
                <div class="col-md-12 col-xs-12">
                  <single-file-upload2
                    :id="'addPlanFileId' + index"
                    @emit-upload-start="saving = true"
                    @emit-upload-end="saving = false"
                    :label="$t('views.plandownloadcenter.file')"
                    :tags="[selectedPlan.UniqueIdentifier]"
                    :categories="[file.Identity.FileCategory]"
                    :currentFolder="selectedPlan.Name"
                    :fileUploadUrl="
                      settings.DOCUMENTSERVICEURL + 'api/UploadFiles'
                    "
                    @emit-files="
                      bindFile($event, lang);
                      saving = false;
                    "
                    @emit-upload-error="
                      error = $event;
                      saving = false;
                    "
                    :getFilesUrl="settings.DOCUMENTSERVICEURL + 'api/Files'"
                    :rules="lang.language === 'en' ? [$rules.required] : []"
                    :class="lang.language === 'en' ? required : ''"
                    :files="files"
                    :filesIds="
                      translate(file, lang, 'FileSegment')
                        ? [translate(file, lang, 'FileSegment').PhysicalFileId]
                        : []
                    "
                  />
                </div>
              </div>
            </template>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn
            text
            @click="
              dialogs.edit = false;
              file = null;
              effectiveDate = null;
            "
          >
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn
            color="primary"
            :loading="saving"
            @click="tryUpdateFile"
            :disabled="!valid.edit"
          >
            {{ $t("globals.save") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <v-dialog scrollable v-model="loadingFile" persistent max-width="200">
      <v-card>
        <v-card-title>{{ $t("globals.please_wait") }}</v-card-title>
        <v-card-text>
          <v-container fluid grid-list-md>
            <v-layout row justify-center>
              <v-flex xs12 sm6 md4 lg3>
                <v-progress-circular indeterminate></v-progress-circular>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      scrollable
      v-if="selectedPlan && checkedFiles != null && checkedFiles !== undefined"
      v-model="dialogs.share"
      persistent
      max-width="900"
    >
      <share-member-files
        v-if="dialogs.share"
        :brokerId="selectedPlan.BrokerId"
        :planId="selectedPlan.Id"
        @closeDialog="(e) => (dialogs.share = e)"
        :fileIds="
          checkedFiles.map(
            (o) =>
              o.Current.Translations.filter(
                (t) => t.LanguageCode === language.language
              )[0].FileSegment.PhysicalFileId
          )
        "
        :maxDataRetrieved="10"
      />
    </v-dialog>

    <v-dialog
      scrollable
      v-if="
        selectedItem &&
          selectedItem.Current &&
          selectedItem.Current.Translations
      "
      v-model="dialogs.details"
      persistent
      max-width="900"
    >
      <material-card
        icon="mdi-file-eye-outline"
        :color="$vuetify.theme.themes.light.primary"
        :title="$t('filebrowser.filedetails.file_details')"
      >
        <v-card-text>
          <v-container class="overflow-y-auto">
            <v-row
              v-for="file in selectedItem.Current.Translations"
              :key="file.FileSegment.PhysicalFileId"
            >
              <member-file-details
                v-if="file.LanguageCode === language.language"
                :file="file.FileSegment"
                :createdBy="selectedItem.Current.CreatedBy"
              />
              <v-divider />
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="dialogs.details = false">
            {{ $t("globals.close") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <file-preview
      :fullScreen="true"
      v-if="dialogs.view"
      :view="dialogs.view"
      :fileItem="fileItem"
      @close="
        dialogs.view = false;
        fileItem = null;
      "
    />
    <v-dialog scrollable v-model="dialogs.delete" persistent max-width="500">
      <material-card
        v-if="checkedFiles"
        :title="$t('filebrowser.deletefiles.title')"
        :color="$vuetify.theme.themes.light.error"
        icon="delete"
      >
        <v-card-text>{{ $t("globals.are_you_sure") }}</v-card-text>
        <v-card-actions>
          <v-btn color text @click="dialogs.delete = false" :loading="saving">
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn color="error" text @click="deleteItems" :loading="saving">
            {{ $t("globals.delete") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
  </material-card>
  <div v-else>
    <v-row justify="center">
      <v-progress-circular
        :size="70"
        :width="7"
        color="accent"
        indeterminate
      ></v-progress-circular>
    </v-row>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { ODataProvider as PbasOData } from "pbas-vue-components";
import ErrorHandler from "../components/ErrorHandler";
import { planSetter } from "../mixins/planSetter";
import { saveAs } from "file-saver";
import { base64ToArrayBuffer } from "../utils/file.js";
import ShareMemberFiles from "../components/ShareMemberFiles.vue";
import MemberFileDetails from "../components/MemberFileDetails.vue";
import getPlanFilesHeaders from "../headers/PlanFiles";
import PlanFilesHistoryHeaders from "../headers/PlanFilesHistory";
import { ODataHeader, ODataString } from "pbas-vue-components";
import { translate2 } from "../trans2";
import SingleFileUpload2 from "../components/SingleFileUpload2.vue";
import AutoSelect from "../components/AutoSelect";
import NoAutocompleteTextfield from "../components/NoAutocompleteTextfield";
import FilePreview from "../components/FilePreview.vue";
import TransSelect2 from "../components/TransSelect2";
import { locker } from "../mixins/locker";
import { sortAlphanum } from "../alphanumericSort";
import TransEnum from "../components/TransEnum.vue";

export default {
  components: {
    ErrorHandler,
    ShareMemberFiles,
    MemberFileDetails,
    SingleFileUpload2,
    AutoSelect,
    NoAutocompleteTextfield,
    FilePreview,
    TransSelect2,
    TransEnum,
  },
  data() {
    return {
      stores: [],
      employers: [],
      file: null,
      effectiveDate: null,
      fileItem: null,
      branchHeader: new ODataHeader({
        title: "globals.store",
        type: new ODataString("Store/Current/Translations[]/Name", {
          getString: (item) => {
            if (!item || !item.Store) return "";
            return translate2(item.Store.Current, "Name");
          },
        }),
      }),
      loadingFile: false,
      files: null,
      checkedFiles: null,
      provider: undefined,
      dialogs: {
        add: false,
        share: false,
        delete: false,
        view: false,
        details: false,
        edit: false,
      },
      valid: {
        add: false,
        share: false,
        edit: false,
      },
      error: null,
      rowActions: [
        {
          name: "view",
          icon: "visibility",
          title: "globals.view",
          handler: (item) => {
            const trans = item.Current.Translations.filter(
              (o) => o.LanguageCode === this.language.language
            )[0];
            this.fileItem = trans.FileSegment;
            this.fileItem.Id = trans.FileSegment.PhysicalFileId;
            this.dialogs.view = true;
          },
          visible: (item) => {
            const trans = item.Current.Translations.filter(
              (o) => o.LanguageCode === this.language.language
            )[0];
            return (
              trans.FileSegment.FileType === "Adobe Reader" ||
              trans.FileSegment.FileType === "Image" ||
              trans.FileSegment.FileType === "text"
            );
          },
        },
        {
          name: "previewItem",
          icon: "mdi-file-eye-outline",
          title: "components.membersmanagementtable.details",
          handler: (item) => {
            this.selectedItem = item;
            this.dialogs.details = true;
          },
        },
        {
          name: "downloadFiles",
          icon: "file_download",
          title: "globals.download",
          handler: (item) => {
            this.checkedFiles = [];
            this.checkedFiles.push(item);
            this.downloadFiles();
          },
        },
        {
          name: "shareFile",
          icon: "share",
          title: "globals.share",
          handler: (item) => {
            this.checkedFiles = [];
            this.checkedFiles.push(item);
            this.dialogs.share = true;
          },
        },
        {
          name: "editItem",
          icon: "edit",
          title: "globals.edit",
          handler: (item) => {
            this.selectedItem = item;
            this.dialogs.edit = true;
          },
          visible: () =>
            this.mode === "plan" &&
            (this.role.indexOf("Broker Plan Manager") > -1 ||
              this.role.indexOf("Broker Plan Admin") > -1 ||
              this.role.indexOf("Documents Management Admin") > -1),
        },
        {
          name: "deleteFiles",
          icon: "delete",
          title: "globals.delete",
          handler: (item) => {
            this.checkedFiles = [];
            this.checkedFiles.push(item);
            this.dialogs.delete = true;
          },
          visible: () => {
            return (
              this.role.indexOf("Broker Plan Manager") > -1 ||
              this.role.indexOf("Broker Plan Admin") > -1 ||
              this.role.indexOf("Documents Management Admin") > -1
            );
          },
        },
      ],
      confirmDeleteDialog: false,
      selectedItem: null,
      headers: [],
      saving: false,
      historyHeaders: PlanFilesHistoryHeaders,
    };
  },
  props: ["mode"],
  computed: {
    ...mapGetters("common", { selectedPlan: "plan" }),
    ...mapGetters("common", [
      "settings",
      "language",
      "languages",
      "userEmployers",
    ]),
    ...mapGetters("plansMembers", ["planIdentity", "planOptions", "options"]),
    ...mapGetters("auth", ["user", "role"]),
    filteredCategories() {
      if (this.selectedPlan.PlanType === "NoManaged") {
        if (this.mode === "plan") {
          return this.options.Enums.PlanFileCategory.filter(
            (o) => o !== "RegularRemmitanceUpload" && o !== "OtherUpload"
          );
        } else {
          return this.options.Enums.PlanFileCategory.filter(
            (o) => o === "RegularRemmitanceUpload" || o === "OtherUpload"
          );
        }
      }
      return this.options.Enums.PlanFileCategory;
    },
    floatActions() {
      if (
        (this.mode === "plan" &&
          (this.role.indexOf("Documents Management Admin") > -1 ||
            this.role.indexOf("Broker Plan Admin") > -1 ||
            this.role.indexOf("Broker Plan Manager") > -1)) ||
        (this.mode === "employer" &&
          (this.role.indexOf("Employer Plan Admin") > -1 ||
            this.role.indexOf("Employer Members Viewer") > -1))
      ) {
        return [
          {
            name: "addItem",
            icon: "add",
            color: this.$vuetify.theme.themes.light.success,
            text: "globals.add_new",
            handler: () => {
              this.addFile();
            },
          },
        ];
      }
      return [];
    },
    selectActions() {
      if (
        this.role.indexOf("Broker Plan Manager") > -1 ||
        this.role.indexOf("Broker Plan Admin") > -1 ||
        this.role.indexOf("Documents Management Admin") > -1
      ) {
        return [
          {
            name: "downloadFiles",
            icon: "file_download",
            title: "globals.download",
            handler: (item) => {
              this.checkedFiles = item;
              this.downloadFiles();
            },
          },
          {
            name: "shareFile",
            icon: "share",
            title: "globals.share",
            handler: (item) => {
              this.checkedFiles = item;
              this.dialogs.share = true;
            },
          },
          {
            name: "deleteFiles",
            icon: "delete",
            title: "globals.delete",
            handler: (item) => {
              this.checkedFiles = item;
              this.dialogs.delete = true;
            },
          },
        ];
      }
      return [
        {
          name: "downloadFiles",
          icon: "file_download",
          title: "globals.download",
          handler: (item) => {
            this.checkedFiles = item;
            this.downloadFiles();
          },
        },
        {
          name: "shareFile",
          icon: "share",
          title: "globals.share",
          handler: (item) => {
            this.checkedFiles = item;
            this.dialogs.share = true;
          },
        },
      ];
    },
  },
  mixins: [locker, planSetter],
  watch: {
    selectedPlan: {
      handler() {
        this.headers = getPlanFilesHeaders(
          this.selectedPlan.PlanType,
          this.mode
        );
        this.loadPlanData();
      },
    },
    effectiveDate: {
      async handler(v) {
        console.log("date is: ", v);
        if (v) {
          this.loadingFile = true;
          try {
            this.file = await this.lock(
              this.getPlanFileByDate,
              {
                planIdentityId: this.selectedPlan.Id,
                planFileIdentityId: this.selectedItem.Id,
                date: v,
                dialogs: this.dialogs,
                dialog: "edit",
              },
              () => {
                this.dialogs.edit = false;
              }
            );
            this.files = [];
          } catch (error) {
            this.error = error;
          } finally {
            this.loadingFile = false;
          }
        }
      },
    },
    "file.Identity.Employer": {
      handler(v) {
        if (v) {
          if (this.planOptions.HasStores) {
            if (v.Stores) {
              const collator = new Intl.Collator(undefined, {
                numeric: true,
                sensitivity: "base",
              });
              this.stores = v.Stores.filter(
                (o) => o.Current!==null && o.Current !== undefined && o.Current.IsAssignable !== false
              ).sort(collator.compare);
            }
            if (
              !v.Stores ||
              v.Stores.filter((o) =>
                this.file.Identity.Store
                  ? o.Id === this.file.Identity.Store.Id
                  : false
              ).length === 0
            ) {
              this.file.Identity.Store = null;
              this.file.Identity.StoreId = null;
            }
          }
        } else {
          this.stores = [];
        }
      },
    },
  },
  async mounted() {
    if (this.selectedPlan !== null && this.selectedPlan !== undefined) {
      this.headers = getPlanFilesHeaders(this.selectedPlan.PlanType, this.mode);
      this.loadPlanData();
    }
  },
  methods: {
    ...mapActions("documentsService", ["downloadFile"]),
    ...mapActions("plansMembers", [
      "deletePlanFiles",
      "addPlanFile",
      "getEmployersDropDown",
      "getPlanFileByDate",
      "updatePlanFile",
    ]),
    generateDependantProvider(item) {
      const url =
        "plans/" + this.selectedPlan.Id + "/plan-files/" + item.Id + "/history";
      const identityHeaders = this.headers.filter(
        (o) =>
          (o.visible === true && o.allowVisibilityChange === true) ||
          o.allowVisibilityChange === false
      );
      const actualHeaders = this.historyHeaders.filter(
        (h) => identityHeaders.filter((o) => o.title === h.title).length > 0
      );
      return new PbasOData(this.$axiosHttp, url, actualHeaders);
    },
    translate(item, language, field) {
      let translation = item.Translations.filter(
        (o) => o.LanguageCode === language.language
      );
      if (translation.length > 0) {
        return translation[0][field];
      }
      return undefined;
    },
    translate2(item, field) {
      return translate2(item, field);
    },
    bindFile(physicalFile, language) {
      // console.log(physicalFile);
      if (physicalFile !== null && physicalFile !== undefined) {
        const file = physicalFile.file;
        let existing = this.file.Translations.filter(
          (o) => o.LanguageCode === language.language
        );
        if (existing.length > 0) {
          const index = this.file.Translations.indexOf(existing[0]);
          this.file.Translations[index].FileSegment = {
            FileName: file.Name,
            FileSize: file.FileSize,
            FileType: file.ExtensionType.FileType,
            Timestamp: file.DateCreated,
            PhysicalFileId: file.Id,
          };
        } else {
          this.file.Translations.push({
            LanguageCode: language.language,
            FileSegment: {
              FileName: file.Name,
              FileSize: file.FileSize,
              FileType: file.ExtensionType.FileType,
              Timestamp: file.DateCreated,
              PhysicalFileId: file.Id,
            },
          });
        }
        // this.file.Timestamp = file.DateCreated;
        this.files.push(physicalFile);
      } else {
        this.file.Translations = this.file.Translations.filter(
          (o) => o.LanguageCode !== language.language
        );
      }
    },
    bindName(name, language) {
      if (name !== null && name !== undefined) {
        let existing = this.file.Translations.filter(
          (o) => o.LanguageCode === language.language
        );
        if (existing.length > 0) {
          const index = this.file.Translations.indexOf(existing[0]);
          this.file.Translations[index].Name = name;
        } else {
          this.file.Translations.push({
            LanguageCode: language.language,
            Name: name,
          });
        }
      } else {
        this.file.Translations = this.file.Translations.filter(
          (o) => o.LanguageCode !== language.language
        );
      }
    },
    async loadPlanData() {
      let headers = this.headers.concat([]);
      if (this.planOptions.HasStores) {
        headers = this.headers.concat([this.branchHeader]);
      }
      this.provider = new PbasOData(
        this.$axiosHttp,
        "plans/" + this.selectedPlan.Id + "/plan-files",
        headers
      );
      if (this.mode === "employer") {
        this.provider.filter =
          "FileCategory eq 'RegularRemmitanceUpload' or FileCategory eq 'OtherUpload'";
      } else {
        this.provider.filter =
          "FileCategory ne 'RegularRemmitanceUpload' and FileCategory ne 'OtherUpload'";
      }
      // const collator = new Intl.Collator(undefined, {
      //   numeric: true,
      //   sensitivity: "base",
      // });
      const employers = (await this.getEmployersDropDown({
        plan: this.selectedPlan.Id,
        // url:
        //   "employers?$expand=Current($expand=Translations;$select=IdentityId,Name),Stores($expand=Current($expand=Translations;$select=IdentityId,Name,IsAssignable);$select=Id)&$select=Id",
      })).data.sort((a, b) => {
        const translatedA = a.Current.Translations.filter(
          (o) => o.LanguageCode === this.language.language
        )[0].Name;
        const translatedB = b.Current.Translations.filter(
          (o) => o.LanguageCode === this.language.language
        )[0].Name;
        // console.log(translatedA, translatedB);
        return sortAlphanum(translatedA, translatedB);
      });

      if (this.mode === "plan") {
        this.employers = employers;
      } else if (this.mode === "employer") {
        console.log(employers, this.userEmployers);
        this.employers = employers.filter(
          (o) => this.userEmployers.filter((e) => e === o.Id).length > 0
        );
      }
    },
    async downloadFiles() {
      this.loadingFile = true;
      const ids = this.mapPlanFilesIds(this.checkedFiles);
      try {
        if (ids.length === 0) {
          throw {
            customMessage: "No file ids",
          };
        }
        console.log("ids: ", ids);
        const res = (await this.downloadFile({ ids: ids })).data;
        const blob = this.$files.b64toBlob(res);
        const name =
          ids.length > 1 ? "files.zip" : this.getFileName(this.checkedFiles[0]);
        saveAs(blob, name);
      } catch (error) {
        this.error = error;
      } finally {
        this.loadingFile = false;
      }
    },
    getFileName(planFile) {
      const trans = planFile.Current.Translations.filter(
        (o) => o.LanguageCode === this.language.language
      );
      if (trans.length > 0) {
        return trans[0].FileSegment.FileName;
      }
      return "file";
    },
    mapPlanFilesIds(planFiles) {
      console.log(planFiles);
      const ids = [];
      for (const planFile of planFiles) {
        if (planFile.Current && planFile.Current.Translations) {
          const trans = planFile.Current.Translations.filter(
            (o) => o.LanguageCode === this.language.language
          );
          if (trans.length > 0) {
            ids.push(trans[0].FileSegment.PhysicalFileId);
          }
        }
      }
      return ids;
    },
    async deleteItems() {
      const options = {
        planIdentityId: this.selectedPlan.Id,
        payload: { Ids: this.checkedFiles.map((o) => o.Id) },
      };
      try {
        this.saving = true;
        await this.deletePlanFiles(options);
      } catch (error) {
        this.error = error;
      } finally {
        this.saving = false;
        this.dialogs.delete = false;
        this.$refs.table.getDataAsync();
      }
    },
    async tryAddFile() {
      this.saving = true;
      try {
        let item = JSON.parse(JSON.stringify(this.file));
        // if (this.mode === "employer") {
        //   item.Identity.EmployerId = this.getEmployerIdFromToken();
        // } else {
        if (
          item.Identity.Employer !== null &&
          item.Identity.Employer !== undefined
        ) {
          item.Identity.EmployerId = item.Identity.Employer.Id;
          delete item.Identity.Employer;
        }
        if (item.Identity.Store !== null && item.Identity.Store !== undefined) {
          item.Identity.StoreId = item.Identity.Store.Id;
          delete item.Identity.Store;
        }
        // }

        await this.addPlanFile({
          planIdentityId: this.selectedPlan.Id,
          payload: item,
        });
        this.dialogs.add = false;
        this.file = null;
        this.files = null;
        this.$refs.table.getDataAsync();
      } catch (error) {
        this.error = error;
      } finally {
        this.saving = false;
      }
    },
    async tryUpdateFile() {
      this.saving = true;
      try {
        let item = JSON.parse(JSON.stringify(this.file));

        delete item.Identity;
        item.EffectiveDate = this.effectiveDate;
        await this.updatePlanFile({
          planIdentityId: this.selectedPlan.Id,
          payload: item,
        });
        this.dialogs.edit = false;
        this.file = null;
        this.files = null;
        this.$refs.table.getDataAsync();
      } catch (error) {
        this.error = error;
      } finally {
        this.saving = false;
      }
    },
    addFile() {
      this.file = {
        Identity: {
          PlanIdentityId: this.selectedPlan.Id,
        },
        Translations: [],
        CreatedBy: this.user,
      };
      if (this.mode === "employer") {
        this.file.EffectiveDate =
          new Date().toISOString().split("T")[0] + "T00:00:00.0000000Z";
        if (this.employers.length === 1) {
          this.file.Identity.Employer = this.employers[0];
        }
      }
      this.files = [];
      this.dialogs.add = true;
      console.log(JSON.stringify(this.file));
    },
    getEmployerIdFromToken() {
      return this.userEmployers[0];
    },
  },
};
</script>
<style>
.centered-div {
  margin-left: auto;
  margin-right: auto;
}
</style>
